<h4>{{tableTitle}}</h4>

<table 
  #dataTable 
  class="row-border hover display">
  <thead>
    <tr>
      <th *ngFor="let column of tableColumnTitles">{{column}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of tableData; let i = index;">
      <ng-container
        [ngTemplateOutlet]="tableTemplateRef"
        [ngTemplateOutletContext]="{$implicit: data, index: i}"
      ></ng-container>
    </tr>
  </tbody>
</table>
